// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_MasterStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/accounts/master_status/{provider}
 *
 * Locally composed status payload — does NOT passthrough provider data.
 * Contains only non-sensitive configuration info about the master account.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsFranchises_MasterStatusResponseDados {
provider_code: string
is_configured: boolean
environment?: string
api_url?: string
}

export type SubaccountsFranchises_MasterStatusResponse = ApiResponse<SubaccountsFranchises_MasterStatusResponseDados>;

registerResponseContract('SubaccountsFranchises_MasterStatusResponse', {
  provider_code: { type: 'string',  required: true },
  is_configured: { type: 'boolean', required: true },
  environment:   { type: 'string',  required: false },
  api_url:       { type: 'string',  required: false },
})
